import { Component, OnInit } from '@angular/core';
import { EntityDirectoryService } from '../../entity-directory.service';
import { Router } from '@angular/router';
import { prefix } from 'src/app/v2/constants';

@Component({
  selector: 'entity-hierarchy',
  templateUrl: './hierarchy.component.html',
  styleUrls: ['./hierarchy.component.scss']
})
export class EntityHierarchyComponent implements OnInit {

  constructor(public service: EntityDirectoryService,
    private _router: Router) { }

  ngOnInit() {
  }

  /**
   * Goes to the dashboard page for the selected entity ID.
   */
  gotoDashboard(entityId) {
    this._router.navigate([prefix, 'entity', entityId, 'dashboard']);
  }
}
